// @ts-nocheck
import _ from 'lodash';
import lscache from 'lscache';

const DEFAULT_TTL_MINUTES = 5;

// Extends lscache with some convenience methods for our use cases
export default {
  setTransientIfEmpty(key, value, forceSet = false) {
    const existingData = lscache.get(key);

    if (existingData === null || forceSet) {
      return this.setTransient(key, value);
    }
  },
  setTransient(key, value) {
    return lscache.set(key, value, DEFAULT_TTL_MINUTES);
  },
  getBackwardsCompatible(key) {
    if (typeof localStorage !== 'undefined' && localStorage !== null) {
      let localStorageValue = localStorage.getItem(key);

      // If we had a value with this key in plain localStorage, move to lscache
      if (localStorageValue !== null) {
        // Try parsing it so we store it as an object (this is what lscache does)
        try {
          localStorageValue = JSON.parse(localStorageValue);
        } catch (e) {
          // Just keep the string value if it's not a valid JSON
        }

        // "move" from localStorage to lscache
        if (lscache.set(key, localStorageValue)) {
          localStorage.removeItem(key);
        }
      }
    }

    return lscache.get(key);
  },
  getOrElse(key, defaultValue) {
    const cachedValue = lscache.get(key);

    return _.isNil(cachedValue) ? defaultValue : cachedValue;
  },
  ...lscache,
};
